export default __webpack_public_path__ + "static/media/CRS_7107-HDR-min.ad5c541a.jpg";